var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120 150c22.91 0 43.09-6.254 59.754-14.234-16.918 31.832-27.055 68.68-29.066 106.68C83.043 249.706 30 306.456 30 376c0 74.441 60.559 136 135 136 22.934 0 44.902-6.46 64.605-17.27C199.04 464.766 180 422.086 180 376s19.04-87.766 49.605-117.73c-15.171-8.325-31.703-13.985-48.964-16.184 6.523-106.023 86.593-193.477 189.832-209.434C344.18 69.566 330 113.613 330 159.86v82.657C262.684 250.09 210 306.69 210 376c0 74.441 60.559 136 135 136s135-61.559 135-136c0-69.309-52.684-125.91-120-133.484v-82.657c0-50.714 19.746-98.394 55.605-134.254L441.211 0H405c-70.453 0-134.305 28.73-180.504 75.074C212.367 63.43 173.476 30 120 30 56.719 30 13.418 77.152 11.324 79.16L0 90l11.324 10.84C13.418 102.848 56.72 150 120 150zm225 181c-24.813 0-45 20.188-45 45h-30c0-41.352 33.648-75 75-75zm-180 0c-24.813 0-45 20.188-45 45H90c0-41.352 33.648-75 75-75zm0 0",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlots);
export default __webpack_public_path__ + "static/media/slots.5c9caed1175ff1ff77647076090daeb7.svg";
export { ForwardRef as ReactComponent };